import{SignalType}from"./Signal";function isPageViewCountSignal(i){return i.type==SignalType.PageViewCount}export{isPageViewCountSignal};